/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum Frequency {
  ONEMIN = '60 Seconds',

  FIVEMIN = '5 Minutes',

  TENMIN = '10 Minutes',

  FIFTEENMIN = '15 Minutes',

  TWENTYMIN = '20 Minutes',
}
